// DocTypeBadge — brief 84 band B, candidate B49.
// The file-type badge the CaseView and CollectiveCaseView document rows
// rendered byte-identically. The third copy — the App documents TABLE's —
// differs by one style property (marginRight: 5 for a table cell, where
// these use flexShrink: 0 in a flex row): a rendered-layout hunk with no
// parameter, so it stays there, per move-integrity-standard 1b.
import { FS, CT, RAD } from "../lib/tokens";

export function DocTypeBadge({ ftI }: any) {
  return (
                            <span
                              style={{
                                fontSize: FS.s8_5,
                                fontWeight: 700,
                                color: CT.c_fff,
                                background: ftI.c,
                                borderRadius: RAD.r3,
                                padding: "1px 4px",
                                flexShrink: 0,
                              }}
                            >
                              {ftI.l}
                            </span>
  );
}
